import { CoreSetupAuditTrailViewsName } from './name';
import { createAddCollectionSyncSlice } from '@sonar-software/xuder';
import { getCoreSetupAuditTrailViewsSlice } from './get';
import { SetupAuditTrailView } from '@types';

export const addCoreSetupAuditTrailViewsSyncSlice = createAddCollectionSyncSlice({
	add: (view: SetupAuditTrailView) => view,
	hasRequest: true,
	name: CoreSetupAuditTrailViewsName,
	state: getCoreSetupAuditTrailViewsSlice.asyncState
});
